// External Libraries
import { useState, useRef, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "./index.css";  // correct global CSS import

// Contexts and Themes
import { ColorModeContext, useMode } from "./theme/theme";
import { CompanyManagementRoutes, CostingManagementRoutes, CustomerRoutes, DashBoardRoutes, ExampleRoutes, GeneralRoutes, HRManagementRoutes, MasterRoutes, OrderRoutes, PurchaseAndProductionRoutes, SalesRoutes, TransactionRoutes, UserRoutes, WarehouseRoutes } from "./routes";
import Layout from "./Layout/Layout";
import { callApi } from "./utils/apiClient";
import { API_ENDPOINTS } from "./config/api/apiCall";
import Login from "./features/login";
import Chat from "./features/chat/Chat";
import DeckleMatchingPlanner from "./features/planning/DecklePlanner";

// Constants
const INACTIVITY_TIMEOUT = 60 * 60 * 1000; // 60 minutes in milliseconds

function App() {

  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(() => Boolean(localStorage.getItem("userID")));
  const inactivityTimer = useRef(null);
  const navigate = useNavigate();

  // Handles user logout
  const handleLogout = () => {

    // call reject reel process
    const parameter = {
      userid: localStorage.getItem('userID'),
      password: localStorage.getItem('userPassword'),
    };

    callApi(API_ENDPOINTS.USER_logout, 'POST', { 'Content-Type': 'application/json' }, parameter)
      .then(data => {
        if (data && data.length > 0) {
          localStorage.removeItem("userID");
          localStorage.removeItem("userPassword");
          setIsLoggedIn(false);
          navigate("/signin");
        }
      })
      .catch(error => {
        alert("Unable to Logout", 'Please check API connection');
      });

  };

  // Resets the inactivity timer
  const resetInactivityTimer = () => {
    if (inactivityTimer.current) {
      clearTimeout(inactivityTimer.current);
    }
    inactivityTimer.current = setTimeout(handleLogout, INACTIVITY_TIMEOUT);
  };

  // Adds event listeners to track user activity
  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    const resetTimerOnActivity = () => resetInactivityTimer();
    events.forEach((event) =>
      window.addEventListener(event, resetTimerOnActivity)
    );

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetTimerOnActivity)
      );
      clearTimeout(inactivityTimer.current);
    };
  }, [isLoggedIn]);

  return (
   
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>     
        <CssBaseline />
        {isLoggedIn ? (
          <Layout onLogout={handleLogout}>
            <Routes>
              {GeneralRoutes(isLoggedIn, setIsLoggedIn)}
              {GeneralRoutes(isLoggedIn, setIsLoggedIn)}
              {CustomerRoutes}
              {ExampleRoutes}
              {OrderRoutes}
              {MasterRoutes}
              {TransactionRoutes}
              {SalesRoutes}
              {PurchaseAndProductionRoutes}
              {WarehouseRoutes}
              {DashBoardRoutes}
              {UserRoutes}
              {CompanyManagementRoutes}
              {HRManagementRoutes}
              {CostingManagementRoutes}
            </Routes>
            <ToastContainer />
          </Layout>
        ) : (
          <Routes>
            <Route path="/signin" element={<Login onLogin={() => setIsLoggedIn(true)} />} />
            <Route path="*" element={<Navigate to="/signin" />} />
          </Routes>
        )}
         {/* <DeckleMatchingPlanner /> */}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
export default App;



